import {
  B_21,
  BANNER_DEFAULTS,
  hideB21Props,
} from "@stadium/shared/src/helpers/plasmic/static-slices";

export const B21_PLASMIC_PROPS = {
  b21Heading: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_21].heading,
    description: "Main heading (B21 only)",
    hidden: hideB21Props,
  },
  b21Description: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_21].description,
    description: "Description text (B21 only)",
    hidden: hideB21Props,
  },
  b21PrimaryButtonText: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_21].primaryButtonText,
    description: "Primary CTA button text (B21 only)",
    hidden: hideB21Props,
  },
  b21PrimaryButtonUrl: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_21].primaryButtonUrl,
    description: "Primary CTA button URL (B21 only)",
    hidden: hideB21Props,
  },
  b21BackgroundVector: {
    type: "imageUrl",
    description: "Background vector image (B21 only)",
    hidden: hideB21Props,
  },
  b21Watermark: {
    type: "imageUrl",
    defaultValue: BANNER_DEFAULTS[B_21].watermark,
    description: "Watermark image (B21 only)",
    hidden: hideB21Props,
  },
};
